import { FilterType } from "src/api/types";
import { TITLE } from "src/constants/searchParams";

export const filters: FilterType[] = [
  {
    name: TITLE,
    placeholder: "Title",
    type: "text",
  },
];
